import { z } from 'zod'

import { BillingTypeZ, TripContentAllowanceZ } from '@/types/billing'

export const CompanyIdZ = z.number().brand<'CompanyId'>()

export type CompanyId = z.infer<typeof CompanyIdZ>

export const CompanyFeatureFlagsZ = z
	.object({
		enable_debug_ui: z.boolean(),
		enable_non_traditional_accommodation: z.boolean(),
		enable_vpa: z.boolean(),
		enable_new_hotel_experience: z.boolean(),
		enable_new_downgrade_package: z.boolean(),
		enable_genesys_chat_bot: z.boolean(),
		enable_invoices_mock: z.boolean(),
		enable_mock_configurations: z.boolean(),
		enable_sncf_per_company: z.boolean(),
		enable_sso_ui: z.boolean(),
		enable_ob_fees: z.boolean(),
		enable_car_external_booking: z.boolean(),
		enable_alternative_fares_improvements: z.boolean(),
	})
	.partial()

export type CompanyFeatureFlags = z.infer<typeof CompanyFeatureFlagsZ>

// eslint-disable-next-line no-restricted-syntax
export enum CompanyPreferenceType {
	CcEmails = 'cc_emails',
}

export const CompanyPreferenceTypeZ = z.enum(CompanyPreferenceType)

// eslint-disable-next-line no-restricted-syntax
export enum CompanyType {
	Normal = 'normal',
	Demo = 'demo',
	Restricted = 'restricted',
}

export const CompanyTypeZ = z.enum(CompanyType)

// TODO: There are missing pieces like the User schema
export const CompanyPreferenceZ = z.object({
	preference_type: CompanyPreferenceTypeZ,
	enabled: z.boolean(),
	description: z.string().nullable(),
	excluded_users: z.array(z.unknown()), // User[],
	included_users: z.array(z.unknown()), // User[],
})

// TODO: There are missing pieces like the User schema
export const CompanyZ = z.object({
	accepted_tos: z.boolean().optional(),
	billing_type: BillingTypeZ,
	bmis: z.string().nullable(),
	company_contact_person: z.unknown().nullable(), // User | null
	company_type: CompanyTypeZ,
	country: z.unknown().optional(), // POSCountry?,
	created_dt: z.string(),
	feature_flag: CompanyFeatureFlagsZ.nullable(),
	flights_allowance: TripContentAllowanceZ,
	gpo: z
		.object({
			id: z.number(),
			name: z.string(),
		})
		.nullable(),
	has_failed_fees: z.boolean().optional(),
	hotels_allowance: TripContentAllowanceZ,
	id: CompanyIdZ,
	is_after_onboarding: z.boolean(),
	logo_url: z.string().nullable(),
	name: z.string(),
	number_of_reward_programs: z.number(),
	preferences: z.array(CompanyPreferenceZ),
	recommended_package_id: z.number().nullable(),
	recommended_pricing_model_id: z.number().nullable(),
	reports_enabled: z.boolean(),
})

export const FeatureFlagZ = z.object({
	enable_sncf_per_company: z.boolean(),
})

export const CompanyFeatureFlagZ = z.object({
	feature_flag: FeatureFlagZ,
})

export type CompanyFeatureFlag = z.infer<typeof CompanyFeatureFlagZ>
